import Front from "@frontapp/plugin-sdk";
import { useEffect, useState } from "react";

import type { ApplicationContext } from "@/modules/customer-service/types";

// Type for single conversation context (subset of ApplicationContext)
type SingleConversationContext = Extract<
  ApplicationContext,
  { type: "singleConversation" }
>;

/**
 * Hook to access Front Plugin SDK context
 * Provides access to conversation, teammate, and Front methods
 */
export const useFrontContext = () => {
  const [context, setContext] = useState<SingleConversationContext | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Subscribe to Front SDK context updates
    const subscription = Front.contextUpdates.subscribe((newContext) => {
      // Only handle single conversation contexts (sidebar plugin)
      if (newContext.type === "singleConversation") {
        setContext(newContext as SingleConversationContext);
      }
      setIsLoading(false);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return {
    context,
    isLoading,
    front: Front,
  };
};
